/**
 * Created by LIDHCRT on 9/17/2018.
 */
module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData","employee",
                      function (Service, $q, brand, brandConfig, session, sessionData, employee) {

                          new Service({
                                          name: 'lifeEventRules',
                                          group:"eprsvc",
                                          url:"/eprsvc/x-services/secure/enrollments/v1",
                                          headers: {},
                                          getLifeEventRules: function() {
                                              this.url += "/special-enrollment-rules";
                                              console.log("in service");
                                              this.headers['FromDP'] = sessionData.basicInfo.loginId;
                                             return this.get();
                                              // return [{lifeEventId:1,lifeEventDescription:'Adoption',beforeDays:'0',afterDays:'61'},
                                              //     {lifeEventId:2,lifeEventDescription:'Birth',beforeDays:'0',afterDays:'61'},
                                              //     {lifeEventId:3,lifeEventDescription:'Death of applicant',beforeDays:'0',afterDays:'60'},
                                              //     {lifeEventId:4,lifeEventDescription:'Divorce/legal separation',beforeDays:'0',afterDays:'60'},
                                              //     {lifeEventId:5,lifeEventDescription:'Legal guardianship',beforeDays:'0',afterDays:'61'},
                                              //     {lifeEventId:6,lifeEventDescription:'Loss of Medicaid or CHIP',beforeDays:'0',afterDays:'60'},
                                              //     {lifeEventId:7,lifeEventDescription:'Loss of previous coverage',beforeDays:'45',afterDays:'60'},
                                              //     {lifeEventId:8,lifeEventDescription:'Marriage',beforeDays:'45',afterDays:'30'},
                                              //     {lifeEventId:9,lifeEventDescription:'Other',beforeDays:'45',afterDays:'61'},
                                              //     {lifeEventId:10,lifeEventDescription:'Returning from armed forces',beforeDays:'0',afterDays:'30'}];

                                              },
                                            fetch: function () {
                                                this.url += "/open-enrollment";
                                                this.headers['FromDP'] = sessionData.basicInfo.loginId;
                                                return this.get();
                                            },
                                          checkOpenEnrollment: function() {
                                              return this.fetch().then(function (resp) {
                                                                           if (
                                                                               resp &&
                                                                               resp.data &&
                                                                               resp.data.payload)

                                              {var output = false;
                                                  // var response1 =  [{openEnrollmentStartDate:'2018-07-01T00:00:00Z',openEnrollmentEndDate:'2018-09-20T00:00:00Z'},{openEnrollmentStartDate:'2018-11-01T00:00:00Z',openEnrollmentEndDate:'2018-11-18T00:00:00Z'},{openEnrollmentStartDate:'2018-11-19T00:00:00Z',openEnrollmentEndDate:'2018-12-01T00:00:00Z'}
                                                  // ];
                                                  var response = resp.data.payload;
                                                  if (response.length) {
                                                      for (var i = 0; i < response.length; i++) {
                                                          var bus = employee.checkSep(response[i].openEnrollmentStartDate, response[i].openEnrollmentEndDate);
                                                          if (bus) {
                                                              output = false;
                                                              break;
                                                          } else {
                                                              output = true;
                                                              continue;
                                                          }
                                                      }

                                                  }
                                                  return output;
                                              }

                                              }

                                              );
                                          }
                                      });
                      }]);
};


